import React from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';
import { toKebabCase } from '@leadhome/utils';
import { AreaLink, MainAreaLink } from 'styles';
import { FeaturedAreas, FeaturedAreasList } from 'styles/search';
import useLocationlessQuery from 'utils/hooks/use-locationless-query';

const FeaturedProvinces = ({ provinces, locationLinkPrefix }) => {
  let displayProvinces = provinces;
  const isMobile = useMedia('(min-width: 426px) and (max-width: 767px)');
  const isPhone = useMedia('(max-width: 425px)');
  if (isMobile) {
    displayProvinces = provinces.slice(0, 2);
  } else if (isPhone) {
    displayProvinces = [];
  }

  let queryString = useLocationlessQuery();
  if (queryString) queryString = `?${queryString}`;

  return (
    <FeaturedAreas>
      {displayProvinces?.map(({ id, name, featuredTowns }) => {
        const provinceKebab = toKebabCase(name);
        return (
          <FeaturedAreasList key={`province_${id}`}>
            <li>
              <MainAreaLink
                href={`${locationLinkPrefix}/${provinceKebab}/${id}${queryString}`}
              >
                {name}
              </MainAreaLink>
            </li>
            {featuredTowns.map((town) => (
              <li key={`featured_town_${town.id}`}>
                <AreaLink
                  href={`${locationLinkPrefix}/${provinceKebab}/${toKebabCase(
                    town.name
                  )}/${town.id}${queryString}`}
                >
                  {town.name}
                </AreaLink>
              </li>
            ))}
          </FeaturedAreasList>
        );
      })}
      <FeaturedAreasList>
        <li>
          <AreaLink href='/search/all-provinces'>All provinces</AreaLink>
        </li>
      </FeaturedAreasList>
    </FeaturedAreas>
  );
};

FeaturedProvinces.propTypes = {
  provinces: PropTypes.array,
  locationLinkPrefix: PropTypes.string
};

FeaturedProvinces.defaultProps = {
  locationLinkPrefix: '/search/property-for-sale'
};

export default React.memo(FeaturedProvinces);
